export interface UserRespose {
  firstName: string;

  lastName: string;

  vuaId: string;

  mobileNumber: string;
}
const initState = {
  user: {
    firstName: "",
    lastName: "",
    vuaId: "",
    mobileNumber: "",
  },
};

export default function user(
  state: { user: UserRespose } = initState,
  action: any
) {
  switch (action.type) {
    case "STORE_USER":
      return {
        ...state,
        user: action.payload.user,
      };
    default:
      return state;
  }
}
